import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex" }

import { ref, computed, watch } from "vue"
import FormRow from "@/components/Common/FormRow.vue"
import EmailGenerate from "@/components/AccountParts/EmailGenerate.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountTextRow',
  props: {
    title: {},
    errors: {},
    type: { default: 'text' },
    id: {},
    modelValue: {},
    textType: {},
    required: { type: Boolean, default: false },
    disabled: { type: Boolean },
    isGenerate: { type: Boolean, default: false },
    driverId: {},
    officeId: {},
    generateButtonName: {}
  },
  emits: ['update:modelValue', 'generate'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const errorsArray = ref([] as string[])

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

function displayError(errors: string[]) {
  errorsArray.value = errors
}

watch(() => props.errors, (value) => {
  errorsArray.value = value
})

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(FormRow, {
    title: props.title,
    text: modelValue.value,
    required: props.required
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_text_field, {
          id: __props.id,
          "hide-details": "auto",
          class: "small pt-2",
          modelValue: modelValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
          type: "text",
          density: "compact",
          disabled: props.disabled,
          "error-messages": errorsArray.value
        }, null, 8, ["id", "modelValue", "disabled", "error-messages"]),
        (props.isGenerate)
          ? (_openBlock(), _createBlock(EmailGenerate, {
              key: 0,
              class: "ml-4 mt-2",
              driverId: props.driverId,
              officeId: props.officeId,
              modelValue: modelValue.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event)),
              buttonName: props.generateButtonName,
              onDisplayError: displayError
            }, null, 8, ["driverId", "officeId", "modelValue", "buttonName"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title", "text", "required"]))
}
}

})